module.exports = __webpack_public_path__ + "img/information.92bfa32d.svg";